// extracted by mini-css-extract-plugin
export default {"followButton":"wU-z","followCount":"xU-z","textStyle":"yU-z"};